import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Grid from "../shared/grid"
import BackgroundImage from "gatsby-background-image"
import Statistics from "./stats"
import { HeroOverlay } from "./hero.style"
import Breakpoints from "../shared/breakpoints"
import { Title, Description } from "../shared/hero.style"
import Spacer from "../../design-system/atoms/layout-primitives/spacer.tsx"

const Hero = () => {
  const { mobileImage, tabletImage, desktopImage } = useStaticQuery(
    graphql`
      query {
        mobileImage: file(
          relativePath: {
            eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Digital Directory/Hero Images/hero 360px.jpg"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 600) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        tabletImage: file(
          relativePath: {
            eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Digital Directory/Hero Images/hero 768px.jpg"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 1000) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        desktopImage: file(
          relativePath: {
            eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Digital Directory/Hero Images/hero 1440px.jpg"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 1440) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  )

  const images = [
    mobileImage.childImageSharp.fluid,
    {
      ...tabletImage.childImageSharp.fluid,
      media: `(min-width: ${Breakpoints.md})`,
    },
    {
      ...desktopImage.childImageSharp.fluid,
      media: `(min-width: ${Breakpoints.lg})`,
    },
  ]

  return (
    <BackgroundImage 
        fluid={images}
        loading="eager"
        fadeIn={false}
    >
      <Grid overlayStyle={HeroOverlay}>
        <Title>Digital Directory Software</Title>
        <Description>
          Mappedin’s Digital Directory enables users to search, discover, and
          navigate through complex indoor venues. Built using our Web SDK, this
          pre-built application pulls navigation features together to serve a
          complete solution.
        </Description>
      </Grid>
      <Spacer 
        variants={[{ backgroundColor: "rgba(240, 240, 240, 0.7)" }]}
        height={{ sm: "1px", md: "1px", lg: "1px" }} 
      />
      <Statistics />
    </BackgroundImage>
  )
}

export default Hero
